<template>
  <WsMain>
    <WsCRUD
      pageMode
      rowClickRead
      :label="label"
      :fields="fields"
      :sortBy="sortBy"
      :showExpand="false"
      :modelName="modelName"
      :showFields="showFields"
      :filterSelects="filterSelects"
    />
  </WsMain>
</template>

<script>
import model from '@/models/announcement';

export default {
  data() {
    return {
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      showFields: [
        'name',
        'is_released',
        'alliance',
        'released_at',
        'released_admin',
        'updated_at',
        'updated_admin',
      ],
      sortBy: 'updated_at',
      filterSelects: [
        {
          type: 'belongsTo',
          textKey: 'name',
          modelName: 'alliance',
          placeholder: '篩選聯盟',
        },
      ],
    };
  },
};
</script>